import React from "react";
import TableMain from "../Common/table/TableMain";
import PointTableFilter from "../Common/table/PointTableFilter";
import { getLastPage } from "../../utils/getLastPage";
import { useTranslation } from "react-i18next";
import Select from "react-select";

const VolumesTable = (props) => {
  const { t } = useTranslation();
  const [selectedValue, setSelectedValue] = React.useState([]);
  const headers = [
    t("month"),
    t("year"),
    t("4KCActive"),
    t("totalPv"),
    t("personalPv"),
    t("leaderPv"),
    t("guestPv"),
    t("nonManagerPv"),
    t("passPv"),
    t("ativeManagers"),
    t("LbQualified"),
    t("RecoLeaderSatus"),
    // t("personalRmpv"),
    // t("nonManagerRmpv"),
    // t("newRmpv"),
    // t("passRmpv"),
    // t("leaderRmpv"),
    // t("totalRmpv"),
  ];
  const totals = [
    "Total",
    "",
    "",
    props?.data?.totals?.totalPv,
    props?.data?.totals?.personalPv,
    props?.data?.totals?.leadershipPv,
    props?.data?.totals?.guestPv,
    props?.data?.totals?.nonManagerPv,
    props?.data?.totals?.passPv,
    "",
    "",
    "",
    props?.data?.totals?.personalRmpv,
    props?.data?.totals?.nonManagerRmpv,
    props?.data?.totals?.newRmpv,
    props?.data?.totals?.passRmpv,
    props?.data?.totals?.leaderRmpv,
    props?.data?.totals?.totalRmpv,
  ];
  const Months = [
    {
      label: t("January"),
      value: "1",
    },
    {
      label: t("February"),
      value: "2",
    },
    {
      label: t("March"),
      value: "3",
    },
  ];
  const handleSelectChange = (selectedOptions) => {
    setSelectedValue(selectedOptions);
  };

  const lastPage = getLastPage(props.itemsPerPage, props?.data?.totalCount);
  return (
    <div className="ewallet_table_section">
      <div className="ewallet_table_section_cnt">
        {/* <div className="filter_Section" >
          <div className="row">
            <div key={"1"} className="col-xl-2 col-md-3">
            <div className="right_search_div">
              <label className="la-control">{t("Month")}</label>
              <Select
                options={Months}
                value={selectedValue}
                onChange={handleSelectChange}
                isMulti
              />
            </div>
            </div>
            <div key={"2"} className="col-xl-2 col-md-3">
            <div className="right_search_div">
              <label className="la-control">{t("Year")}</label>
              <Select
                options={Months}
                value={selectedValue}
                onChange={handleSelectChange}
                isMulti
              />

            </div>
            </div>
          </div>
        </div> */}
        <div className="table-responsive min-hieght-table">
          <TableMain
            headers={headers}
            data={props?.data?.data}
            startPage={1}
            currentPage={props.currentPage}
            totalPages={props?.data?.totalPages}
            type={props.type}
            itemsPerPage={props.itemsPerPage}
            setItemsPerPage={props.setItemsPerPage}
            setCurrentPage={props.setCurrentPage}
            setEpinSortOptions={props.setSortOptions}
            totals={totals}
          />
        </div>
      </div>
    </div>
  );
};

export default VolumesTable;
